import { Avatar, Box, Stack, Typography } from '@mui/material'
import moment from 'moment'
import React, { useContext } from 'react'
import { JustDot } from 'src/assets/inboxHub/InboxHubIcons'
import TextWithDotBetween from './TextWithDotBetween'
import { InboxHubContext } from 'src/pages/InboxHub'
// import FileAttachmentBar from './FileAttachmentBar'
import parse from 'html-react-parser'
import { stringAvatar } from '@utils/inboxHubUtils'

const Reply = ({ reply, key }) => {
  const { date, from, to, isReplied, subject, bodyTextHtml } = reply
  const formattedDate = moment(date).format('DD/MM/YY')
  const formattedTime = moment(date).format('hh:mm A')
  // const attachments = [
  //   { name: 'document.pdf', url: '/uploads/document.pdf' },
  //   { name: 'chart.xlsx', url: '/uploads/chart.xlsx' },
  //   { name: 'img_2025.png', url: '/uploads/img_2025.png' },
  //   { name: 'presentation.pptx', url: '/uploads/presentation.pptx' }
  // ]
  const cleanHtml = (emailContent) => {
    return emailContent.replace(/<p(\s[^>]*)?>/gi, '<div$1>').replace(/<\/p>/gi, '</div>')
  }

  return (
    <Box key={key} sx={{ backgroundColor: '#FFF', border: '1px solid #28287B1A', borderRadius: 1 }}>
      <Box sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.22)', px: 2 }}>
        <Box
          sx={{
            py: 1.5,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'left', md: 'center' },
            gap: { xs: 2, md: 0 },
            borderBottom: '1px solid #28287B1A'
          }}
        >
          <EmailFromTo from fromTo={from} />
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}
          >
            <Typography sx={{ fontSize: '12px', color: '#8181B0' }}>
              <TextWithDotBetween
                dotColor='#8181B0'
                dotSize='3'
                textArray={[formattedTime, formattedDate]}
              />
            </Typography>
            <Stack
              direction='row'
              gap={1}
              sx={{
                display: 'flex',
                width: 'fit-content',
                height: 'fit-content',
                alignItems: 'center',
                border: '1px solid rgba(0, 0, 0, 0.14)',
                borderRadius: 1,
                px: 1
              }}
            >
              <JustDot color={isReplied ? '#3F4FF8' : '#00AA38'} />
              <Typography color='#344054' fontWeight={600} fontSize='14px'>
                {isReplied ? 'Replied' : 'Opened'}
              </Typography>
            </Stack>
          </Box>
        </Box>
        <Box sx={{ py: 1.5, borderBottom: '1px solid #28287B1A' }}>
          <EmailFromTo from={false} fromTo={to} />
        </Box>
        <Box sx={{ py: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ color: '#8181B0', fontSize: '14px' }}>Subject:</Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>{subject}</Typography>
        </Box>
      </Box>
      <Box sx={{ p: 2 }}>
        {/* <Typography sx={{ fontSize: '14px', whiteSpace: 'pre-line' }}>{bodyText}</Typography> */}
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 500,
            lineHeight: '20px',
            // color: `${theme.palette.primary.primaryText}`,
            mt: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            flexDirection: 'column'
          }}
        >
          {parse(cleanHtml(bodyTextHtml))}
        </Typography>
      </Box>
      {/* <FileAttachmentBar attachments={attachments} /> */}

    </Box>
  )
}

export default Reply

const EmailFromTo = ({ from, fromTo }) => {
  const { currentlyOpenedEmail, isMobile } = useContext(InboxHubContext)

  const fromAccountEmail = currentlyOpenedEmail?.fromAccount?.email ?? ''
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography sx={{ color: '#8181B0', fontSize: '14px' }}>{from ? 'From:' : 'To:'}</Typography>
      <Avatar {...stringAvatar(`${fromTo ?? ''} ${fromTo ?? ''}`, 25)} />
      <Box>
        {isMobile
          ? (
            <Stack>
              <Typography key={0} sx={{ fontWeight: 600, fontSize: '14px' }}>
                {getNameAndEmailForReply(fromTo, fromAccountEmail)?.[0]}
              </Typography>
              <Typography key={1} sx={{ fontSize: '14px' }}>
                {getNameAndEmailForReply(fromTo, fromAccountEmail)?.[1]}
              </Typography>
            </Stack>
            )
          : (
            <TextWithDotBetween
              dotColor='#000000'
              dotSize='3'
              textArray={[
                <Typography key={0} sx={{ fontWeight: 600, fontSize: '14px' }}>
                  {getNameAndEmailForReply(fromTo, fromAccountEmail)?.[0]}
                </Typography>,
                <Typography key={1} sx={{ fontSize: '14px' }}>
                  {getNameAndEmailForReply(fromTo, fromAccountEmail)?.[1]}
                </Typography>
              ]}
            />
            )}
      </Box>
      <Box />
    </Box>
  )
}

function getNameAndEmailForReply (inputFromTo, fromAccountEmail) {
  const cleanFromTo = inputFromTo.match(/"([^"]+)"\s+<([^>]+)>/)
  if (fromAccountEmail === (cleanFromTo?.[2] ? cleanFromTo?.[2] : inputFromTo)) {
    return ['You', (cleanFromTo?.[2] ? cleanFromTo?.[2] : inputFromTo)]
  }
  return cleanFromTo ? [cleanFromTo?.[1], cleanFromTo?.[2]] : ['', inputFromTo]
}
